import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import React, { FC } from 'react';
import { Commentary, UserCommentary, TypeLabel } from '../commentary.types';
import styles from './commentary_subtext.module.scss';

type Props = {
  isDoctrineLink?: boolean;
  commentary: Commentary | UserCommentary;
};

export const CommentarySubtext: FC<Props> = ({
  commentary,
  isDoctrineLink = false,
}) => (
  <span
    className={classNames(
      styles.container,
      commentary.typeLabel === TypeLabel.PAPER && styles.paper,
    )}
  >
    {commentary.author && (
      <span className={styles.item}>{commentary.author}</span>
    )}

    {commentary.sourceName && (
      <span className={styles.item}>{commentary.sourceName}</span>
    )}
    {isDoctrineLink && (
      <span className={styles.item}>
        <FormattedMessage id="commentary/card/CommentarySubtext.tsx/1" />
      </span>
    )}
    {commentary.dateHtml && (
      <span
        className={classNames(styles.date, {
          [styles.datePaper]: commentary.typeLabel === TypeLabel.PAPER,
          [styles.paper]:
            commentary.author || commentary.sourceName || isDoctrineLink,
        })}
        dangerouslySetInnerHTML={{
          __html: commentary.dateHtml,
        }}
      />
    )}
  </span>
);
